import ZeroSession from "./HeroSession";
import HeroSession from "./HeroSession";
import PercentageCard from "./PercentageCard";
import PercentageCardDesign from "./PercentageCardDesign";
// import PercentageCardSecond from "./PercentageCardSecond";
// import PercentageDashboard from "./PercentageDashboard";
import SimpleBarChart from "./SimpleBarChart";
import SimplePieChart from "./SimplePieChart";

const Analysis = () => {
  return (
    <div className="flex flex-col mt-10 gap-4">
      
      <SimpleBarChart />
      <SimplePieChart/>
      <ZeroSession/>
      <PercentageCard />
      {/* <PercentageCardSecond/> */}
      <PercentageCardDesign/>
    </div>
  );
};

export default Analysis;
  